/**
 * Create React App entry point. This and `public/index.html` files can not be
 * changed or moved.
 */
import React from "react";
import axios from "axios";
// import ReactDOM from "react-dom";
import { createRoot } from 'react-dom/client';

import { initializeIcons } from '@fluentui/react/lib/Icons';
import { registerLicense } from "@syncfusion/ej2-base";

// import { registerLicense } from '@syncfusion/ej2-base';
import { MetronicI18nProvider } from "./_metronic/i18n";
import {
  MetronicLayoutProvider,
  MetronicSplashScreenProvider,
  MetronicSubheaderProvider
} from "./_metronic/layout";
import App from "./app/App";
import store, { persistor } from "./redux/store";
import * as _redux from "./redux";

import "./index.scss"; // Standard version
import "./custom.scss";
import "./archem.scss";
import "./payroll.scss";
import "./grid.scss";
// import "./sass/style.react.rtl.css"; // RTL version
import "./_metronic/_assets/plugins/keenthemes-icons/font/ki.css";
import "socicon/css/socicon.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./_metronic/_assets/plugins/flaticon/flaticon.css";
import "./_metronic/_assets/plugins/flaticon2/flaticon.css";
import "./_metronic/_assets/plugins/line-awesome/css/line-awesome.css";
import "./_metronic/_assets/plugins/themify/themify-icons.css";
// // import "./_metronic/_assets/plugins/bootstrapicons/bootstrap.css";
import "./_metronic/_assets/plugins/icofont/icofont.min.css";
import "./_metronic/_assets/plugins/fontello/css/payroll.css";
import "./_metronic/_assets/sass/pages/wizard/wizard-2.scss";

// Datepicker
// import "react-datepicker/dist/react-datepicker.css";
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

registerLicense("ORg4AjUWIQA/Gnt2XVhhQlJHfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hTX9RdEZjUH9YcHNRRmle");
// registerLicense("ORg4AjUWIQA/Gnt2U1hhQlJBfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hTX5Vd0ZhWHxecnNWQGlU");
// registerLicense("ORg4AjUWIQA/Gnt2UFhhQlJBfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hTX5Qd0BhW31Wc3FSQWVU")
// // registerLicense("ORg4AjUWIQA/Gnt2UVhiQlZPd11dXmJWd1p/THNYflR1fV9DaUwxOX1dQl9nSXxRdkdjWn1aeXBURGA=");
// // registerLicense("ORg4AjUWIQA/Gnt2UVhhQlVFfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hSn9Rd0xhW39adXBVQGhZ");
// registerLicense("ORg4AjUWIQA/Gnt2VlhhQlJCfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hSn5adEdhWHxWc3BWQGdV");
// registerLicense("ORg4AjUWIQA/Gnt2VFhhQlJDfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hSn5QdURhWH5Zc3FVRGVc");
// registerLicense("ORg4AjUWIQA/Gnt2VVhkQlFacl9JXGFWfVJpTGpQdk5xdV9DaVZUTWY/P1ZhSXxQdkRjW35XdXZRQ2lfUkw=");
// registerLicense("ORg4AjUWIQA/Gnt2VVhjQlFaclhJXGFWfVJpTGpQdk5xdV9DaVZUTWY/P1ZhSXxRd0VhWH9ecnZURWZbVEQ=");
// registerLicense("ORg4AjUWIQA/Gnt2VVhiQlFadVlJXGFWfVJpTGpQdk5xdV9DaVZUTWY/P1ZhSXxRdkJhXX9dcXdVR2JfVkI=");
// import { registerLicense } from '@syncfusion/ej2-base';

// registerLicense("ORg4AjUWIQA/Gnt2VVhiQlFadVlJXGFWfVJpTGpQdk5xdV9DaVZUTWY/P1ZhSXxRdkJhXX9dcXdVR2JfVkI=");
/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const { PUBLIC_URL } = process.env;

/**
 * Creates `axios-mock-adapter` instance for provided `axios` instance, add
 * basic Metronic mocks and returns it.
 *
 * @see https://github.com/ctimmerm/axios-mock-adapter
 */
/* const mock =  _redux.mockAxios(axios);*/

/**
 * Inject metronic interceptors for axios.
 *
 * @see https://github.com/axios/axios#interceptors
 */
_redux.setupAxios(axios, store);

initializeIcons();

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <MetronicI18nProvider>
    <MetronicLayoutProvider>
      <MetronicSubheaderProvider>
        <MetronicSplashScreenProvider>
          <App store={store} persistor={persistor} basename={PUBLIC_URL} />
        </MetronicSplashScreenProvider>
      </MetronicSubheaderProvider>
    </MetronicLayoutProvider>
  </MetronicI18nProvider>
);

// ReactDOM.render(
//   <MetronicI18nProvider>
//     <MetronicLayoutProvider>
//       <MetronicSubheaderProvider>
//         <MetronicSplashScreenProvider>
//           <App store={store} persistor={persistor} basename={PUBLIC_URL} />
//         </MetronicSplashScreenProvider>
//       </MetronicSubheaderProvider>
//     </MetronicLayoutProvider>
//   </MetronicI18nProvider>,
//   document.getElementById("root")
// );
